<template>
  <div class="main no-padding-top">
    <div class="carousel">
      <!-- <el-carousel trigger="click" :loop="false" arrow="always" indicator-position="none">
        <el-carousel-item > -->
      <div class="swiper_content">
        <div class="title">
          <div class="slogan">企业数据BI运营</div>
          <div class="exp">数据在手，胸有成竹，知微见著，决策千里</div>
          <!--          <div class="btn">立即体验</div>-->
        </div>
        <img :src="serve" alt="img" />
      </div>
      <!-- </el-carousel-item>
      </el-carousel> -->
    </div>
    <div class="mobile_bg">
      <img :src="require('../assets/img/index/mobilebg.jpg')" alt="" />
    </div>
    <div class="main_content_bg bg1">
      <div class="main_title">
        <h3>功能优势</h3>
        <p>
          <span class="grey">透视数据价值观察，助力企业智慧经营</span
          ><span class="red"></span>
        </p>
      </div>
      <div class="main_content">
        <div
            class="content_item shadow"
            v-for="(item, i) in service_list"
            :key="i"
        >
          <div class="item_icon">
            <img :src="item.img" :alt="item.title" />
          </div>
          <div class="item_text">
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="main_content_bg bg2">
      <img
          class="bg_img"
          :src="require('../assets/img/index/bg2.jpg')"
          alt="解决痛点"
      />
      <div class="main_title">
        <h3>解决痛点</h3>
        <p>
          <span class="grey">企业经营可视化管理，稳固长存提质增效</span
          ><span class="red"></span>
        </p>
      </div>
      <div class="main_content">
        <div class="content_item" v-for="(item, i) in resolve_list" :key="i">
          <div class="item_icon">
            <img :src="item.img" :alt="item.title" />
          </div>
          <div class="item_text">
            <div class="title">{{ item.title }}</div>
            <!--            <div class="text">{{ item.text }}</div>-->
            <div class="text" v-for="(text, index) in item.text" :key="index">
              {{ text }}
            </div>
          </div>
        </div>
        <img
            class="bg_img2"
            :src="require('../assets/img/index/ss.png')"
            alt="解决痛点"
        />
      </div>
    </div>
    <div class="main_content_bg bg3">
      <img
          class="bg_img"
          :src="require('../assets/img/index/bg3.jpg')"
          alt="核心功能"
      />
      <div class="main_title">
        <h3>选择我们</h3>
        <p>
          <span class="grey">经营可视化，企业良性发展</span
          ><span class="red"></span>
        </p>
      </div>
      <div class="main_content">
        <div class="content_item" v-for="(item, i) in chose_list" :key="i">
          <div class="item_icon">
            <img :src="item.img" :alt="item.title" />
          </div>
          <div class="item_text">
            <div class="title">{{ item.title }}</div>
            <div class="text" v-for="(text, index) in item.text" :key="index">
              {{ text }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import serve from '../assets/img/index/pcbg.jpg';
// import storage from "../assets/img/storage.jpg"
export default {
  data() {
    return {
      serve: serve,
      list: [
        { text: '上海百醇软件有限公司 为你的每一笔订单负责', img: serve },
        // ,{text:"全渠道统一对接 快速处理订单、商品、库存问题",img:storage}
      ],
      service_list: [
        {
          img: require('../assets/img/index/g1.png'),
          title: '数据大屏',
          text: '经营大屏、业绩大屏、商品大屏、会员大屏、电商大屏，核心KPI概览',
        },
        {
          img: require('../assets/img/index/g2.png'),
          title: '经营报告',
          text: '业绩概览、同环比、达成率、渠道对比、四周趋势，商品结构、价格带分布、销售TOP榜',
        },
        {
          img: require('../assets/img/index/g3.png'),
          title: '店铺经营',
          text: '门店成本利润分析、店效人效坪效跟踪分析、门店断码分析、售罄率情况、销售损失预测、各项TOP榜',
        },
        {
          img: require('../assets/img/index/g4.png'),
          title: '会员经营',
          text: 'RFM会员价值体系分析、用户留存分析、复购率、用户下单习惯、用户结构分析（年龄性别等）',
        },
        {
          img: require('../assets/img/index/g5.png'),
          title: '商品经营',
          text: '大类-季节-年份库存分布、尺码结构分布、断码缺货率、库存周转率、区域库存分布等',
        },
        {
          img: require('../assets/img/index/g6.png'),
          title: '库龄经营',
          text: '大类-季节库龄分布、库龄各项分类统计、销售周期与库龄关系分析、在库商品库龄明细',
        },
        {
          img: require('../assets/img/index/g7.png'),
          title: '销售经营',
          text: '销售ABC分析、贡献度分析、购物篮关联分析、区域及大类分析、价格带分析、折扣分析等',
        },
        {
          img: require('../assets/img/index/g8.png'),
          title: '移动可视化',
          text: '销售日报周报月报、门店经营数据、区经导购日常报表数据、管理驾驶舱数据',
        },
      ],
      resolve_list: [
        {
          img: require('../assets/img/index/a1.png'),
          title: '决策者',
          text: ['经营全局概览可视化数据决策支撑', '数据资产价值转变企业社会价值'],
        },
        {
          img: require('../assets/img/index/a2.png'),
          title: '管理者',
          text: ['企业经营更具商业智能', '经营过程更具灵活可视'],
        },
        {
          img: require('../assets/img/index/a3.png'),
          title: '经营者',
          text: ['解放双手劳力转向智力经营', '预判经营风险盲区无处可藏'],
        },
        {
          img: require('../assets/img/index/a4.png'),
          title: 'IT信息',
          text: ['数据孤岛由繁入简', '依赖服务商转向自主可用'],
        },
      ],
      chose_list: [
        {
          img: require('../assets/img/index/icon_1.png'),
          title: '专业',
          text: [
            '二十年零售行业经验累积',
            '专业的团队陪伴企业发展'
          ],
        },
        {
          img: require('../assets/img/index/icon_2.png'),
          title: '安全',
          text: [
            '阿里云、帆软等技术合作',
            '安全机制符合各平台要求'
          ],
        },
        {
          img: require('../assets/img/index/icon_3.png'),
          title: '易用',
          text: [
            '操作简单开户即用',
            '不用开发匹配调整',
          ],
        },
        {
          img: require('../assets/img/index/icon_4.png'),
          title: '服务',
          text: [
            '7X24小时服务支持',
            '全程免费培训帮助'
          ],
        },
      ],
    };
  },
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}

@media screen and (min-width: 1200px) {
  .main {

    &.no-padding-top {
      padding-top: 0 !important;
    }

    .swiper_content {
      max-height: 700px;
      background: white;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title {
        position: absolute;
        left: 50%;
        margin-left: -600px;
        color: #fff;
        line-height: 1;

        .slogan {
          font-size: 60px;
        }

        .exp {
          margin-top: 25px;
          font-size: 16px;
          color: rgba(255, 255, 255, 0.5);
        }

        .btn {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 64px;
          font-size: 14px;
          width: 140px;
          height: 40px;
          border-radius: 5px;
          border: 1px solid #FFFFFF;
          cursor: pointer;

          &:hover {
          }
        }
      }

      img {
        width: 100%;
      }
    }

    .carousel {
      position: relative;
      overflow: hidden;

      .el-carousel__container {
        height: 750px;
      }

      .el-carousel__item {
        h3 {
          color: white;
          font-size: 34px;
          line-height: 430px;
          margin: 0;
          text-align: center;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: 0 -160px;

          span {
            line-height: 1;
            padding: 10px;
            border-radius: 10px;
            background: rgba(0, 0, 0, 0.1);
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }

    .mobile_bg {
      display: none;
    }

    .main_content_bg {
      padding-top: 100px;

      .main_title {
        text-align: center;
        color: #333;

        h3 {
          margin: 0 0 30px;
          font-size: 32px;
          font-weight: 400;
          color: #333333;
          position: relative;
          letter-spacing: 4px;

          &:after {
            content: "";
            position: absolute;
            left: calc(50% - 32px);
            bottom: -10px;
            width: 60px;
            height: 3px;
            background: #0167F8;
          }
        }

        .grey {
          font-size: 18px;
          letter-spacing: 2px;
          color: #666;
        }

        .red {
          font-size: 20px;
          color: rgb(228, 57, 42);
        }
      }

      .main_content {
        display: flex;
        justify-content: space-around;
        width: 1200px;
        margin: 0 auto;
        padding-bottom: 60px;
        flex-wrap: wrap;

        .content_item {
          background: white;
          text-align: center;
          padding-top: 24px;
          width: 250px;
          height: 200px;
          box-sizing: border-box;
          margin-top: 60px;

          .item_icon {
            width: 52px;
            display: inline-block;
            margin-bottom: 15px;

            img {
              width: 100%;
              display: block;
            }
          }

          .item_text {
            width: 224px;
            margin: 0 auto;
            color: #333;

            .title {
              font-size: 18px;
              margin-bottom: 10px;
            }

            .text {
              font-size: 14px;
              line-height: 20px;
              color: #999;
            }
          }
        }
      }

      &.bg1 {
        padding-top: 100px;
        position: relative;

        .main_title {
          color: #333;

          .grey {
            color: #666;
          }
        }
      }

      &.bg2 {
        position: relative;

        .bg_img {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          z-index: -1;
          object-fit: cover;
        }

        .main_title {

          h3 {
            color: #fff;

            &:after {
              background: #fff;
            }
          }

          .grey {
            color: rgba(255, 255, 255, 0.7);
          }
        }


        .main_content {
          position: relative;
          width: 1100px;
          min-height: 500px;
          justify-content: space-between;
          margin-top: 60px;

          .bg_img2 {
            width: 313px;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            margin-left: -50px;
            top: 0;
            z-index: -1;
          }

          .content_item {
            background: none;
            width: 240px;
            display: flex;
            position: absolute;

            &:first-child {
              left: 88px;
              top: -10px;
              margin-top: 0;
              padding-top: 0;

              .item_text {
                text-align: right;
              }
            }

            &:nth-child(2) {
              left: 670px;
              top: -10px;
              margin-top: 0;
              padding-top: 0;
            }

            &:nth-child(3) {
              left: 88px;
              top: 120px;

              .item_text {
                text-align: right;
              }
            }

            &:nth-child(4) {
              left: 670px;
              top: 120px;
            }

            .item_icon {
              display: none;
            }

            .item_text {
              text-align: left;
              flex: 1;

              .title {
                font-size: 18px;
                margin-top: 20px;
                margin-bottom: 10px;
                color: #fff;
              }

              .text {
                line-height: 22px;
                font-size: 14px;
                color: rgb(255, 255, 255, 0.7);
              }
            }
          }
        }
      }

      &.bg3 {
        padding-bottom: 60px;
        position: relative;

        .bg_img {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          z-index: -1;
        }

        .main_content {
          .content_item {
            background: #fff;
            border-radius: 5px;
            width: 280px;
            height: 340px;


            .item_icon {
              padding-top: 50px;
            }

            .item_text {
              color: #333333;

              .title {
                font-size: 18px;
                margin-bottom: 30px;
                position: relative;

                &:after {
                  content: "";
                  position: absolute;
                  left: 50%;
                  bottom: -15px;
                  transform: translateX(-50%);
                  width: 20px;
                  height: 3px;
                  background: #0167F8;
                }
              }

              .text {
                font-size: 14px;
                line-height: 20px;
                color: #666666;
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .main {
    background: rgb(240, 242, 245);

    .swiper_content {
      height: 100%;
      background: white;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title {
        color: #ff4536;
        font-size: 54px;
        width: 330px;
        margin: 0 auto;
        text-align: center;

        .bold {
          font-size: 80px;
          color: rgb(8, 60, 126);
        }

        .exp {
          font-size: 16px;
          line-height: 40px;
          background: #073d7d;
          color: rgba(255, 255, 255, 0.8);
          margin-top: 20px;
        }

        .btn {
          margin-top: 60px;
          font-size: 14px;
          width: 124px;
          text-align: center;
          line-height: 40px;
          background: linear-gradient(to right, #ff4536, #ff675b);
          border-radius: 4px;
          color: rgba(255, 255, 255, 0.8);

          &:hover {
            cursor: pointer;
          }
        }
      }

      img {
        display: none;
        height: 570px;
        margin-right: -90px;
      }
    }

    .mobile_bg {
      height: 3.4rem;
      width: 100%;

      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }

    .carousel {
      display: none;
    }

    .main_content_bg {
      padding-top: 0.4rem;

      .main_title {
        text-align: center;
        color: #333;

        h3 {
          font-weight: 500;
          font-size: 0.32rem;
          line-height: 0.44rem;
          margin: 0;
        }

        .grey {
          font-size: 0.24rem;
          line-height: 0.34rem;
          margin-top: 0.14rem;
          color: #666;
          // margin-right: 20px;
        }

        .red {
          font-size: 20px;
          color: rgb(228, 57, 42);
        }
      }

      .main_content {
        display: flex;
        justify-content: space-between;
        margin: 0 0.32rem;
        flex-wrap: wrap;

        .content_item {
          background: white;
          text-align: center;
          padding-top: 24px;
          width: 3.3rem;
          height: 3.3rem;
          box-sizing: border-box;
          margin-top: 0.3rem;

          &.shadow {
            box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.05);
            border-radius: 10px;
          }

          .item_icon {
            width: 0.6rem;
            display: inline-block;
            margin-bottom: 0.05rem;

            img {
              width: 0.6rem;
            }
          }

          .item_text {
            width: 2.74rem;
            margin: 0 auto;
            color: #333;

            .title {
              font-size: 0.32rem;
              margin-bottom: 0.09rem;
            }

            .text {
              color: #999;
              font-size: 0.24rem;
            }
          }
        }
      }

      &.bg1 {
        position: relative;

        .bg_img {
          width: 100%;
          height: 700px;
          position: absolute;
          left: 0;
          top: 0;
          z-index: -1;
          display: none;
        }
      }

      &.bg2 {
        position: relative;
        padding: 2em 0;
        margin-top: 1.5em;

        .bg_img {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
        }

        .main_title {
          position: relative;
          z-index: 2;

          h3 {
            color: #fff;
          }

          .grey {
            color: rgba(255, 255, 255, 0.7);
          }
        }


        .main_content {
          position: relative;
          justify-content: space-between;
          margin-top: 0.3rem;
          z-index: 2;

          .bg_img2 {
            display: none;
          }

          .content_item {
            padding: 0.1rem;
            box-sizing: border-box;
            width: 6rem;
            margin: 0 auto;
            height: 1.6rem;
            border-radius: 1.6rem;
            margin-bottom: 0.4rem;
            box-shadow: 0 0 30px 0px #234eba33;
            display: flex;

            .item_icon {
              width: 1.4rem;
              height: 1.4rem;
              margin-bottom: 0px;

              img {
                width: 100%;
                height: 100%;
                border-radius: 100%;
              }
            }

            .item_text {
              margin-left: 0.3rem;
              text-align: left;
              flex: 1;

              .title {
                font-size: 0.28rem;
                margin-top: 0.16rem;
                margin-bottom: 0.06rem;
              }

              .text {
                line-height: 0.28rem;
                font-size: 0.24rem;
                color: #6782a4;
              }
            }
          }
        }
      }

      &.bg3 {
        position: relative;
        padding-bottom: 2em;

        .bg_img {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          bottom: 0;
          display: block;
        }

        .main_title {
          position: relative;
          z-index: 1;
        }

        .main_content {
          position: relative;
          z-index: 1;

          .content_item {
            background: white;
            text-align: center;
            padding-top: 24px;
            width: 3.3rem;
            height: 3.3rem;
            box-sizing: border-box;
            margin-top: 0.3rem;

            box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.05);
            border-radius: 10px;

            .item_icon {
              width: 0.6rem;
              display: inline-block;
              margin-bottom: 0.05rem;

              img {
                width: 0.6rem;
              }
            }

            .item_text {
              width: 2.74rem;
              margin: 0 auto;
              color: #333;

              .title {
                font-size: 0.32rem;
                margin-bottom: 0.09rem;
              }

              .text {
                color: #666;
                font-size: 0.24rem;
              }
            }
          }


        }
      }
    }
  }
}
</style>
